import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {
  private changePasswordUrl: string = environment.apiUrl + "/change-password/";

  constructor(
    private http: HttpClient
  ) { }

  changePassword(password: any) {
    return this.http.post<any>(this.changePasswordUrl, password);
  }
}
